import { Box, styled } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  overflowX: 'scroll',
  overflowY: 'auto',
  marginRight: theme.spacing(2),
  gap: theme.spacing(2),
  paddingRight: '2px',
  paddingBottom: '2px',
  scrollbarColor: 'inherit transparent' /* for Firefox */,
  '&::-webkit-scrollbar-track': {
    borderRadius: theme.shape.borderRadius,
    background: 'transparent'
  },
  '&::-webkit-scrollbar-corner': {
    background: theme.palette.background.default
  }
}));
